/* app/js/src/components/channel/channel-wizard/done/done.scss */
.cursor-pointer {
  cursor: pointer;
}
#schedulerButton {
  width: 177px;
  background-color: #40c4ff;
  color: #ffffff;
  margin-right: 10px;
}
.buttons {
  margin-top: 44px;
}
.button {
  border-radius: 4px;
  font-size: 13px;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.button.edit {
  width: 154px;
  background-color: #eef2f6;
  color: #232f3a;
}
/*# sourceMappingURL=done.css.map */
